import React from 'react';
import '../../styles/Website/Platforms.css';

function Platforms() {
  const platforms = [
    { name: 'MetaTrader 4', logo: '/mt4.png' },
    { name: 'MetaTrader 5', logo: '/mt5.png' }
  ];

  const tradingPlatforms = [
    { name: 'cTrader', logo: '©️' },
    { name: 'TradingView', logo: 'TV' }
  ];

  const compatibility = [
    { icon: '✓', name: 'Windows' },
    { icon: '✓', name: 'Web Browser' },
    { icon: '✓', name: 'Android' },
    { icon: '✓', name: 'MAC' },
    { icon: '✓', name: 'iOS' }
  ];

  return (
    <section className="platforms" id="platforms">
      <div className="container-wide">
        <div className="platforms-grid">
          <div className="platforms-content">
            <h2 className="section-title-large" style={{color: 'black'}}>Powerful Trading Terminals</h2>
            
            <div className="platform-logos">
              {platforms.map((platform, index) => (
                <div className="platform-logo-card" key={index}>
                  <div className="platform-icon">
                    <img src={platform.logo} alt={platform.name} className="mt-logo" />
                  </div>
                  <span className="platform-name">{platform.name}</span>
                </div>
              ))}
            </div>

            <div className="additional-platforms">
              {tradingPlatforms.map((platform, index) => (
                <div className="additional-platform" key={index}>
                  <div className="platform-badge">{platform.logo}</div>
                  <span>{platform.name}</span>
                </div>
              ))}
            </div>

            <div className="compatibility-grid">
              {compatibility.map((item, index) => (
                <div className="compatibility-item" key={index}>
                  <span className="check-icon">{item.icon}</span>
                  <span>{item.name}</span>
                </div>
              ))}
            </div>

            <button className="btn-cta-secondary">Platforms</button>
          </div>

         <div className="platforms-visual">
            <img className="platforms-hero-img" src="/platform-pc.webp" alt="Meta Frx Ai" />
        </div>
        </div>
      </div>
    </section>
  );
}

export default Platforms;